import { render, staticRenderFns } from "./addOrEditFee.vue?vue&type=template&id=8cf1c710&"
import script from "./addOrEditFee.vue?vue&type=script&lang=js&"
export * from "./addOrEditFee.vue?vue&type=script&lang=js&"
import style0 from "./addOrEditFee.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports